import React, { useState } from "react";
import {
  Flex,
  Box,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
} from "@chakra-ui/react";
import { useAppContext } from "../../../contexts/AppContext";

const InvestmentDocumentsTable = ({ investment }) => {
  const { tableSize, getFileIcon } = useAppContext();
  const [searchTerm, setSearchTerm] = useState("");

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  // Filtrer les documents en fonction du terme de recherche
  const filteredDocuments = investment?.documents.filter((doc) =>
    doc.name.toLowerCase().includes(searchTerm)
  );

  return (
    <Flex direction={"column"} gap={8}>
      {/* Barre de recherche */}
      <Flex flex={1}>
        <Input
          placeholder="Search documents by name..."
          value={searchTerm}
          onChange={handleSearchChange}
          w={"260px"}

        />
      </Flex>

      {filteredDocuments.length > 0 ? (
        <TableContainer>
          <Table variant="simple" size={tableSize}>
            <Thead>
              <Tr>
                <Th>Document Name</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredDocuments.map((doc, index) => (
                <Tr key={index}>
                  <Td fontWeight="500">
                    <Flex align="center" gap={4}>
                      <Box w="20px" h="20px">
                        {getFileIcon(doc.url)}
                      </Box>
                      {doc.name}
                    </Flex>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Box textAlign="center" py={10} color="gray.500">
          No documents found
        </Box>
      )}
    </Flex>
  );
};

export default InvestmentDocumentsTable;
